//Redux
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { closeModal } from "../../reducers/modalReducer";
//Components
import { Modal } from "@allaria-tech/matter/Modal";
import { Feedback } from "@allaria-tech/matter/Feedback";
//Hooks
import useMobileLayout from "../../hooks/useMobileLayout";
//Styles
import styles from "./QRModal.module.scss";

const QRModal = () => {
  const { container, qr } = styles;

  const dispatch = useAppDispatch();

  const { modalName } = useAppSelector((state) => state.modal);
  const { qrImage, scannedQr, successMessage, onClose } = useAppSelector(
    (state) => state.qr,
  );
  // In the app's 560px desktop modal our width reads as a phone, so keep the
  // desktop dialog there. Its frame grows to fit the modal (see
  // startReportingModalHeight), so the modal drops its 85vh cap too.
  const { isCryptoAppModal } = useMobileLayout();

  const isOpen = modalName === "modal-qr";

  const handleClose = () => {
    onClose && onClose();
    dispatch(closeModal());
  };

  if (scannedQr) {
    return (
      <Feedback
        isOpen={isOpen}
        type="SUCCESS"
        title="Mantené la página abierta"
        description={successMessage}
        disableMobileLayout={isCryptoAppModal}
        disableMaxHeight={isCryptoAppModal}
        primaryAction={{
          text: "Entendido",
          onClick: handleClose,
        }}
      />
    );
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      title="Código QR"
      description="Escaneá el código para continuar en tu teléfono."
      primaryAction={{
        text: "Cerrar",
        onClick: handleClose,
      }}
      footerAlignment="right"
      disableMobileLayout={isCryptoAppModal}
      disableMaxHeight={isCryptoAppModal}
    >
      <section className={container}>
        <div className={qr}>
          <img src={qrImage} alt="QR" />
        </div>
      </section>
    </Modal>
  );
};

export default QRModal;
